import React from "react"
import { IContext } from "../models/IContext"

export interface ILoading{
    readonly loading: boolean
}

export type LogState<S> = Partial<S> & Pick<S, keyof unknown>

export abstract class CanLoad<P = unknown, S = unknown> extends React.Component<P, ILoading & S>{
    context: IContext

    constructor(props: P, state: S, loading = false){
        super(props)

        this.state = {
            ...state,
            loading
        }
    }
    
    protected toggleLoading = () => this.setState({ loading: !this.state.loading } as ILoading & S)
}